/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { useEffect, useRef, useState } from 'react';

type BeersOptions = {
  page: number;
  per: number;
};

const defaultOptions: Required<BeersOptions> = {
  page: 1,
  per: 10,
};

const useBeers = (options?: BeersOptions) => {
  const [beers, setBeers] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const optionsRef = useRef({ ...defaultOptions, ...options });

  const [pageNumber, setPageNumber] = useState(optionsRef.current.page);

  const getBeers = async (page: number) => {
    setLoading(true);
    try {
      await fetch(
        `https://api.punkapi.com/v2/beers?page=${page}&per_page=${optionsRef.current.per}`,
      )
        .then(res => {
          return res.ok
            ? res.json()
            : res.json().then(err => Promise.reject(err));
        })
        .then(res => {
          const additionalBeers = res.map((beer: any) => ({
            id: beer.id,
            title: beer.name,
            imageSrc: beer.image_url,
          }));
          setBeers([...beers, ...additionalBeers]);
        });
    } catch (err) {
      setError(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    getBeers(pageNumber);
  }, [pageNumber]); // eslint-disable-line react-hooks/exhaustive-deps

  return { beers, loading, error, setPageNumber };
};

export default useBeers;
